import { Tag } from '@cian/components';
import * as React from 'react';
import { EContractType } from '../../../../json_query';
import { IContractTypeTag } from '../../../state/tags/definitions/contract';

import { tagThemeSmall } from '../tag_theme';
import { TagNew } from '../TagNew';

export interface IContractTypeTagItemProps {
  tag: IContractTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const contractTypeMap = {
  [EContractType.ObjSale]: 'Продажа объекта',
  [EContractType.PermTransfer]: 'Переуступка прав аренды',
  [EContractType.DirectRent]: 'Прямая аренда',
  [EContractType.SubRent]: 'Субаренда',
};

export const ContractTypeTagItem = ({ withNewTag, onDeleteClick, tag }: IContractTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      {contractTypeMap[tag.value]}
    </TagComponent>
  );
};
